import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ItemStock\PrintItemStockLabelController::__invoke
* @see app/Http/Controllers/ItemStock/PrintItemStockLabelController.php
* @route '/api/stock/item/{item}/print-label'
*/
const PrintItemStockLabelController = (args: { item: string | number } | [item: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: PrintItemStockLabelController.url(args, options),
    method: 'get',
})

PrintItemStockLabelController.definition = {
    methods: ["get","head"],
    url: '/api/stock/item/{item}/print-label',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ItemStock\PrintItemStockLabelController::__invoke
* @see app/Http/Controllers/ItemStock/PrintItemStockLabelController.php
* @route '/api/stock/item/{item}/print-label'
*/
PrintItemStockLabelController.url = (args: { item: string | number } | [item: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { item: args }
    }

    if (Array.isArray(args)) {
        args = {
            item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: args.item,
    }

    return PrintItemStockLabelController.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ItemStock\PrintItemStockLabelController::__invoke
* @see app/Http/Controllers/ItemStock/PrintItemStockLabelController.php
* @route '/api/stock/item/{item}/print-label'
*/
PrintItemStockLabelController.get = (args: { item: string | number } | [item: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: PrintItemStockLabelController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ItemStock\PrintItemStockLabelController::__invoke
* @see app/Http/Controllers/ItemStock/PrintItemStockLabelController.php
* @route '/api/stock/item/{item}/print-label'
*/
PrintItemStockLabelController.head = (args: { item: string | number } | [item: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: PrintItemStockLabelController.url(args, options),
    method: 'head',
})

export default PrintItemStockLabelController